import React, { useEffect } from "react";
import { Box, Alert, AlertTitle } from "@mui/material";

const Notification = ({ open, message, type = "info", onClose, duration = 5000 }) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        onClose(); // Automatically call the onClose callback
      }, duration);

      return () => clearTimeout(timer); // Clear the timer on component unmount or if `open` changes
    }
  }, [open, onClose, duration]);

  if (!open) return null;

  const title =
    type === "info"
      ? "Info"
      : type === "success"
      ? "Success"
      : type === "warning"
      ? "Warning"
      : "Error";

  return (
    <Box
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1300,
        width: "500px",
        boxShadow: 3,
      }}
    >
      <Alert
        severity={type}
        onClose={onClose}
        sx={{
          fontSize: "1rem",
        }}
      >
        <AlertTitle>{title}</AlertTitle>
        {message}
      </Alert>
    </Box>
  );
};

export default Notification;
